import { useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../theme";
import ContactsIcon from "@mui/icons-material/Contacts";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import InfoIcon from "@mui/icons-material/Info";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import HandshakeIcon from "@mui/icons-material/Handshake";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import jwtDecode from "jwt-decode";
import Diversity1Icon from "@mui/icons-material/Diversity1";
import { getAccessToken } from "../services/storage";
import { API_URL } from "../api/axios";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import logo from "../frontend/front-end-images/logo.png";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const SideMenu = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState();

  const accessToken = getAccessToken();

  // Decode the access token
  const decodedToken = jwtDecode(accessToken);

  // Extract the payload from the decoded token
  const payload = decodedToken;

  return (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#0b6885 !important",
        },
        "& .pro-menu-item.active": {
          color: "#0b6885 !important",
        },
      }}
    >
      <ProSidebar
        collapsed={isCollapsed}
        style={{ height: "2700px", overflow: "hidden" }}
      >
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="3%"
              >
                <img src={logo} alt="" width="80%" height="40px" />
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box
              mb="20px"
              display="flex"
              alignItems="center"
              style={{ gap: "10px", marginLeft: "10%" }}
            >
              <Box display="flex" justifyContent="center" alignItems="center">
                {payload?.profile_image ? (
                  <img
                    alt=""
                    width="50px"
                    height="50px"
                    src={`${API_URL}/uploads/admin/profile_images/${payload?.profile_image}`}
                    style={{ cursor: "pointer", borderRadius: "50%" }}
                  />
                ) : (
                  <img
                    alt=""
                    width="50px"
                    height="50px"
                    src="https://i.postimg.cc/vZvJdnRS/blank-head-profile-pic-for-a-man.jpg"
                    style={{ cursor: "pointer", borderRadius: "50%" }}
                  />
                )}
              </Box>
              <Box textAlign="left">
                <Typography
                  variant="h5"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  {payload.first_name} {payload.last_name}
                </Typography>
                <Typography variant="h6" color="#0b6885">
                  {payload.is_super_admin ? "Super Admin" : "Admin"}
                </Typography>
              </Box>
            </Box>
          )}

          <Box marginTop="10%" paddingLeft={isCollapsed ? undefined : ""}>
            <Item
              title="Dashboard"
              to="/admin"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Manage Users"
              to="/admin/users"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            {/* <Item
              title="Manage Pages"
              to="/admin/manage-pages"
              icon={<LibraryBooksIcon />}
              selected={selected}
              setSelected={setSelected}
            /> */}
            <Item
              title="About"
              to="/admin/abouts"
              icon={<InfoIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Contacts Us"
              to="/admin/manage-contacts"
              icon={<ContactsIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="FAQs"
              to="/admin/faqs"
              icon={<LiveHelpIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Success Stories"
              to="/admin/success-stories"
              icon={<Diversity1Icon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Blogs"
              to="/admin/blogs"
              icon={<SpeakerNotesIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="News"
              to="/admin/news"
              icon={<NewspaperIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Manage Deals"
              to="/admin/manage-deals"
              icon={<HandshakeIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Members List"
              to="/admin/members-list"
              icon={<FormatListBulletedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default SideMenu;
